module.exports = __webpack_public_path__ + "img/perfil_default.471a1ad3.png";